module.exports = __webpack_public_path__ + "img/ins-advantage2.50e1782a.svg";